import React, { Ref } from 'react';
import { ImperativeAPI } from '../types/imperative-api';
import { ImageField } from '../image-components/image-field';
import { useSignatureImageAlt } from './use-signature-image-alt';

type Props = {
  signer: string;
  signatureGuid: string;
  isFormView?: boolean;
  'data-qa-ref'?: string;
  'data-testid'?: string;
};
function SignatureImageInternal(
  {
    isFormView,
    signer,
    signatureGuid,
    'data-qa-ref': dataQaRef,
    'data-testid': dataTestId,
  }: Props,
  ref: Ref<ImperativeAPI>,
) {
  const altTextMessage = useSignatureImageAlt({ signer });

  return (
    <ImageField
      isFormView={isFormView}
      alt={altTextMessage}
      id={signatureGuid}
      data-qa-ref={dataQaRef}
      data-testid={dataTestId}
      ref={ref}
    />
  );
}

export const SignatureImage = React.forwardRef(SignatureImageInternal);
